module.exports = __webpack_public_path__ + "static/media/multi-platform-moduleC4.e3d23ce1.png";